import { Done, DoNotDisturb } from "@mui/icons-material";

export default function TrueFalseImage({ value, iconColor, notCentered }) {
  return (
    <div className={!notCentered ? "content_centered_horizontally" : ""}>
      {value ? (
        <Done className="text-2xl" style={{ color: iconColor ?? "green" }} />
      ) : (
        <DoNotDisturb
          className="text-lg"
          style={{ color: iconColor ?? "red" }}
        />
      )}
    </div>
  );
}
